// extracted by mini-css-extract-plugin
export default {"container":"PaymentForm_container__f+yJS","defaultPaymentModeContainer":"PaymentForm_defaultPaymentModeContainer__k6TTD"};